__turbopack_context__.v({
  "root": "switch-filter-module-scss-module__ln_NVW__root",
  "title": "switch-filter-module-scss-module__ln_NVW__title",
});
